<template>
    <div class="animated fade-in printable-document border">
        <b-row>
            <b-col class="clearfix">
                <img width="250" alt="Logo" src="img/brand/sf-logo.svg" class="float-left">
                <h1 class="display-5 font-weight-lighter float-left py-1 px-3"><span>{{title}}</span></h1>
            </b-col>
        </b-row>
        <b-row class="mt-2">
            <b-col><span class="font-weight-bold text-sf pr-1">P</span>877.627.3555<span class="font-weight-bold text-sf pl-2 pr-1">E</span>info@superformicf.ca<span class="font-weight-bold text-sf pl-2 pr-1">F</span>403.627.3553</b-col>
        </b-row>
        <b-row class="mb-4">
            <b-col>Box 2696, 1065 Willow Street, Pincher Creek, AB TOK 1W0</b-col>
        </b-row>
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'PrintableDocument',
    components: {},
    props: ['title'],
    data () {
        return {}
    },
    methods: {},
    created() {}
}
</script>
<style>
    .printable-document {
        padding: 0.5cm;
        position: relative;
        height: auto;
        width: 21.59cm;
        background-color: #fff;
    }
    .printable-document h1 {
        font-size: 2.4em;
    }
    .printable-document table {
        border-color: rgba(0,0,0,0.2);
    }
</style>